import React, { useState } from "react";
import { all_routes } from "../../router/all_routes";
import Breadcrumb from "../../../core/common/Breadcrumb/breadcrumb";
import ProfileCard from "../common/profileCard";
import StudentSidebar from "../common/institutionSidebar";
import { Link } from "react-router-dom";
// import SettingsLinks from "./settingsLinks/settingsLinks";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import CustomSelect from "../../../core/common/commonSelect";
import { Country, Gender, maritalStatus } from "../../../core/common/selectOption/json/selectOption";
import { DatePicker } from "antd";
// import SettingsModal from "./settingsModal/settingsModal";
import { useDispatch, useSelector } from "react-redux";
import { Institution, User } from "../../../core/types/types";
import axios from "axios";
import dayjs from 'dayjs';
import { updateUser } from "../../../core/redux/authSlice";
import apiInstance from "../../../utility/apiInstance";

const InstitutionSettings = () => {
    
    const dispatch = useDispatch();

    const user = useSelector((state: any) => state.auth.user);
    const institution = user?.institution;

    const [msg, setMsg] = useState({
        error: false,
        loading: false,
        text: ''
    });

    const [formData, setFormData] = useState<Institution>({
        id: institution?.id || '',
        schoolName: institution?.schoolName || '',
        about: institution?.about || '',
        location: institution?.location || '',
        country: institution?.country || '',
        founded: institution?.founded || '',
        phoneNumber: institution?.phoneNumber || '',
        schoolType: institution?.schoolType || '',
        image: institution.image || {}
    })

    const getModalContainer = () => {
        const modalElement = document.getElementById("add_assignment");
        return modalElement ? modalElement : document.body;
    };

    const handleInputChange = (
        e: any
    ) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }))
    };

    const validate = () => {
        let newErrors = '';

        if (!formData.schoolName?.trim()) newErrors = "School name is required";

        setMsg({
            error: true,
            loading: false,
            text: newErrors
        })

        return newErrors.length === 0
    };

    const updateProfile = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!validate()) return;

        setMsg({
            error: false,
            loading: true,
            text: ''
        });

        try {
            const response = await apiInstance.patch(`/api/institutions/${formData.id}`, formData);
            dispatch(updateUser({
                ...user,
                institution: response.data.doc
            }))
            setMsg({
                error: false,
                loading: false,
                text: 'Profile updated successfully!'
            });

        } catch (error: any) {
            setMsg({
                error: true,
                loading: false,
                text: error.message
            });
        }
    }

    return (
        <>
            <div className="content">
                <div className="container">
                    {/* profile box */}
                    <ProfileCard />
                    {/* profile box */}
                    <div className="row">
                        {/* sidebar */}
                        <StudentSidebar />
                        {/* sidebar */}
                        
                    </div>
                </div>
            </div>
            {/* <SettingsModal /> */}
        </>
    );
};

export default InstitutionSettings;
